import React from 'react';
import classNames from 'classnames';

import css from './IconHotel.module.css';

export const IconHotel = ({ rootClassName, className }) => {
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg
      className={classes}
      xmlns="http://www.w3.org/2000/svg"
      xmlSpace="preserve"
      style={{
        enableBackground: 'new 0 0 64 64',
      }}
      viewBox="0 0 64 64"
    >
      <path d="M3 62h4a1 1 0 0 0 1-1v-3h30v3a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V45a5.01 5.01 0 0 0-4-4.899V31c0-1.654-1.346-3-3-3H9c-1.654 0-3 1.346-3 3v9.101A5.01 5.01 0 0 0 2 45v16a1 1 0 0 0 1 1zm39-2h-2v-3a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v3H4v-8h38v8zM8 31c0-.551.449-1 1-1h28c.551 0 1 .449 1 1v9h-2v-4c0-1.654-1.346-3-3-3h-6c-1.654 0-3 1.346-3 3v4h-2v-4c0-1.654-1.346-3-3-3h-6c-1.654 0-3 1.346-3 3v4H8v-9zm26 9h-8v-4c0-.551.449-1 1-1h6c.551 0 1 .449 1 1v4zm-14 0h-8v-4c0-.551.449-1 1-1h6c.551 0 1 .449 1 1v4zM4 45c0-1.654 1.346-3 3-3h32c1.654 0 3 1.346 3 3v5H4v-5zM61 40H47a1 1 0 0 0-1 1v15h2v-6h12v6h2V41a1 1 0 0 0-1-1zm-13 8v-6h12v6H48z" />
      <path d="M52 44h4v2h-4zM58 33a1.002 1.002 0 0 0 .949-1.317l-2-6A1 1 0 0 0 56 25h-4a1 1 0 0 0-.949.684l-2 6A1 1 0 0 0 50 33h3v3h-2v2h6v-2h-2v-3h3zm-5.279-6h2.559l1.333 4h-5.226l1.334-4z" />
      <path d="m61.409 15.087-29-13a1.005 1.005 0 0 0-.818 0l-29 13A1 1 0 0 0 2 16v12h2V16.647L32 4.096l28 12.552V28h2V16a1 1 0 0 0-.591-.913z" />
      <path d="M25 17c0 3.86 3.14 7 7 7a7.008 7.008 0 0 0 6.903-8.166l-1.973.332A5.006 5.006 0 0 1 32 22c-2.757 0-5-2.243-5-5a5.006 5.006 0 0 1 6.668-4.715l.666-1.886A7.008 7.008 0 0 0 25 17z" />
      <path d="m30.707 15.293-1.414 1.414 2 2a.997.997 0 0 0 1.414 0l7-7-1.414-1.414L32 16.586l-1.293-1.293z" />
    </svg>
  );
};

export default IconHotel;
